import Materials from '../Material/MaterialsTab/MaterialsTab.container';
import Assignments from '../Assignments';
import EducatorArea from '../Material/EducatorArea';
import EngagementPage from '../EngagementPage';

export default [
  {
    id: 'materials',
    title: 'Materials',
    visible: () => true,
    content: Materials,
  },
  {
    id: 'assignments',
    title: 'Assignments',
    visible: () => true,
    content: Assignments,
  },
  {
    id: 'engagement',
    title: 'Engagement',
    visible: ({ isEducator, isStaff, enableEngagementInsights }) =>
      (isEducator || isStaff) && enableEngagementInsights,
    content: EngagementPage,
  },
  {
    id: 'educatorArea',
    title: 'Educator area',
    visible: ({ isEducator, isStaff }) => isEducator || isStaff,
    content: EducatorArea,
  },
];
